import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { SubstructureMaterialClass } from "../../../../http/deckDesigner/types/substructureMaterialClasses";
import useDeckSubstructureMaterialClassesApi from "../../../../http/deckDesigner/useSubstructureMaterialClasses";
import SubstructureMaterialClassForm from "./SubstructureMaterialClassForm";

const AdminSubstructureMaterialClasses: FC = () => {
  const i18n = useI18n();
  const substructureMaterialClassesApi = useDeckSubstructureMaterialClassesApi();

  return (
    <AdminCrudTable<SubstructureMaterialClass>
      filterPrefix="substructure_material_classes"
      useList={substructureMaterialClassesApi.useDeckSubstructureMaterialClasses}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureMaterials.singular}
          </TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureMaterialClasses.modulusOfElasticity}
          </TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.substructureMaterial.name}</TableCell>
          <TableCell>
            {!!item.modulusOfElasticity && `${item.modulusOfElasticity} ${i18n.translation.common.unitGPa}`}
          </TableCell>
        </>
      )}
      onDelete={(item) => substructureMaterialClassesApi.deleteDeckSubstructureMaterialClass(item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.substructureMaterialClasses.singular}
      canAdd
      renderForm={(item, onClose) => (
        <SubstructureMaterialClassForm substructureMaterialClass={item} onClose={onClose} />
      )}
    />
  );
};

export default AdminSubstructureMaterialClasses;
